/**
 * Context Hook (useContext)
 */

import { useContext } from "react";
import AppThemeContext from "./AppTheme.context";
export const AppThemeHook = () => useContext(AppThemeContext)
